module.exports = __webpack_public_path__ + "static/media/grph-stat2-81.0bc7edd3.svg";